<template>
  <div class="section-light contact" id="contact">
    <div class="container">
      <div
        class="columns is-multiline"
        data-aos="fade-in-up"
        data-aos-easing="linear"
      >
        <div class="column is-12 about-me">
          <h1 class="title has-text-centered section-title">
            {{ $t('message.contact.head') }}
          </h1>
        </div>
        <div class="column is-10 is-offset-1">
          <section>
            <b-tabs type="is-boxed">
              <b-tab-item :label="$t('message.contact.orderRequest')" pack="fas" icon="pen">
                <form
                  method="POST"
                  @submit.prevent="submitForm('orderRequest')"
                >
                  <div class="field">
                    <label class="label">{{ $t("message.contact.nameLabel") }}</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        type="text"
                        :placeholder="$t('message.contact.namePlaceholder')"
                        name="name"
                        v-model="contactDetails.name"
                        required
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t("message.contact.emailLabel") }}</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        type="email"
                        :placeholder="$t('message.contact.emailPlaceholder')"
                        name="email"
                        v-model="contactDetails.mail"
                        required
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-envelope"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <b-field :label="$t('message.contact.startDateLabel')">
                      <b-datepicker
                          :placeholder="$t('message.contact.startDatePlaceholder')"
                          :month-names="$t('message.contact.monthNames')"
                          :day-names="$t('message.contact.dayNames')"
                          icon="calendar-alt"
                          v-model="orderRequestForm.startDate"
                          multiple>
                      </b-datepicker>
                    </b-field>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t("message.contact.durationLabel") }}</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        type="number"
                        :placeholder="$t('message.contact.durationPlaceholder')"
                        name="duration"
                        min="1"
                        max="120"
                        v-model="orderRequestForm.duration"
                        required
                      />
                      <span class="icon is-small is-left">
                        <i class="far fa-clock"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t("message.contact.workloadLabel") }}</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        type="number"
                        :placeholder="$t('message.contact.workloadPlaceholder')"
                        name="duration"
                        min="50"
                        max="100"
                        v-model="orderRequestForm.workload"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-percentage"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t("message.contact.locationLabel") }}</label>
                    <b-radio v-model="orderRequestForm.jobLocationType"
                         name="name"
                         native-value="onSite">
                         {{ $t('message.contact.remoteCheckbox.onSite') }}
                    </b-radio>
                    <b-radio v-model="orderRequestForm.jobLocationType"
                         name="name"
                         native-value="remote">
                         {{ $t('message.contact.remoteCheckbox.remote') }}
                    </b-radio>
                    <div class="control has-icons-left" v-if="orderRequestForm.jobLocationType == 'onSite'">
                      <input
                        class="input"
                        type="text"
                        :placeholder="$t('message.contact.locationPlaceholder')"
                        name="postcode"
                        v-model="orderRequestForm.jobLocation"
                        required
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-car-side"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t('message.contact.hourRateLabel') }}</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        type="number"
                        :placeholder="$t('message.contact.hourRatePlaceholder')"
                        name="duration"
                        min="70"
                        max="1000"
                        v-model="orderRequestForm.hourRate"
                        required
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-euro-sign"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <b-field :label="$t('message.contact.getToKnowLabel')">
                        <b-select :placeholder="$t('message.contact.getToKnowPlaceholder')" v-model="orderRequestForm.getToKnowOption">
                            <option v-for="(option, index) in $t('message.contact.getToKnowOptions')" :value="option.value" :key="index">{{ option.description }}</option>
                        </b-select>
                    </b-field>
                    <div class="control has-icons-left" v-if="orderRequestForm.getToKnowOption == 'other'">
                      <input
                        class="input"
                        type="text"
                        :placeholder="$t('message.contact.getToKnowOtherPlaceholder')"
                        name="postcode"
                        v-model="orderRequestForm.getToKnowOther"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-caret-right"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t('message.contact.orderMessageLabel') }}</label>
                    <div class="control">
                      <textarea
                        class="textarea msg-textarea"
                        :placeholder="$t('message.contact.messagePlaceholder')"
                        name="message"
                        v-model="orderRequestForm.message"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control ">
                      <button class="button submit-button">
                        {{ $t('message.contact.submitBtnTxt') }}
                        <i style="padding-left: 8px" class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </b-tab-item>
              <b-tab-item :label="$t('message.contact.otherRequest')" icon="comment-dots">
                <form
                  method="POST"
                  @submit.prevent="submitForm('other')"
                >
                  <div class="field">
                    <label class="label">{{ $t("message.contact.nameLabel") }}</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        type="text"
                        :placeholder="$t('message.contact.namePlaceholder')"
                        name="Name"
                        v-model="contactDetails.name"
                        required
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t("message.contact.emailLabel") }}</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        type="email"
                        :placeholder="$t('message.contact.emailPlaceholder')"
                        name="Email"
                        v-model="contactDetails.mail"
                        required
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-envelope"></i>
                      </span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t('message.contact.messageLabel') }}</label>
                    <div class="control">
                      <textarea
                        class="textarea msg-textarea"
                        :placeholder="$t('message.contact.messagePlaceholder')"
                        name="Message"
                        v-model="contactForm.message"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control ">
                      <button class="button submit-button">
                        {{ $t('message.contact.submitBtnTxt') }}
                        <i style="padding-left: 8px" class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </b-tab-item>
            </b-tabs>
          </section>
        </div>
      </div>
    </div>
    <b-modal :active.sync="loading"
            has-modal-card full-screen :can-cancel="false">
            <div>Loading</div>
    </b-modal>
  </div>
</template>

<script>
const axios = require('axios');
import autosize from 'autosize';

export default {
  name: 'Contact',
  data() {
        return {
            loading: false,
            contactDetails: {
              name: '',
              mail: ''
            },
            orderRequestForm: {
              startDate: [],
              duration: '',
              workload: 100,
              jobLocationType: "onSite",
              jobLocation: '',
              hourRate: '',
              getToKnowOption: null,
              getToKnowOther: '',
              message: ''
            },
            contactForm: {
              message: ''
            }
        }
    },
  mounted() {
    autosize(document.querySelectorAll('.msg-textarea'));
  },
  methods: {
    submitForm(form) {
      const formKey = form == 'orderRequest' ? 'orderRequestForm' : 'contactForm';
      const formData = this[formKey];
      const formType = form == 'orderRequest' ? 'orderRequest' : 'contact';

      const config = {
        // The URL to the request
        url: 'mail.php',

        // HTTP method like GET, POST, PUT, DELETE, HEAD
        method: 'POST',

        // HTTP request headers
        headers: {
            'Content-Type': 'application/json'
        },

        // request body data object
        data: {
          "contactDetails" : this.contactDetails,
          "formType": formType,
          "formData": formData,
          "language": this.$i18n.locale
        },

        // `withCredentials` indicates whether or not cross-site Access-Control requests
        // should be made using credentials
        withCredentials: true,
      };
      this.loading = true;
      var vuejsThis = this;

      axios(config).then(function(response) {
        vuejsThis.loading = false;
        if("data" in response) {
          const data = response.data;
          if("success" in data) {
            vuejsThis.$buefy.notification.open({
                  indefinite: true,
                  message: vuejsThis.$t('message.contact.successfulSentMsg'),
                  position: 'is-top',
                  type: 'is-success',
                  hasIcon: true
              });
          } else if("errMsg" in data) {
            vuejsThis.$buefy.notification.open({
                  indefinite: true,
                  message: data.errMsg,
                  position: 'is-bottom',
                  type: 'is-danger',
                  hasIcon: true
              });
          } else {
            vuejsThis.$buefy.notification.open({
                  indefinite: true,
                  message: vuejsThis.$t('message.contact.serverNotAnsweredAsExpected'),
                  position: 'is-bottom',
                  type: 'is-danger',
                  hasIcon: true
              });
          }
        }
      }).catch(function (error) {
        vuejsThis.loading = false;
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          vuejsThis.$buefy.notification.open({
                indefinite: true,
                message: vuejsThis.$t('message.contact.serverNotAvailable'),
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            });
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);

          vuejsThis.$buefy.notification.open({
                indefinite: true,
                message: vuejsThis.$t('message.contact.connectionError'),
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            });
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);

          vuejsThis.$buefy.notification.open({
                indefinite: true,
                message: vuejsThis.$t('message.contact.connectionError'),
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            });
        }

      }
    );

    }
  }
}
</script>
